import * as React from 'react';
import { Collapse, Container, Navbar, NavbarBrand, NavbarToggler, NavItem, NavLink, Row, Col } from 'reactstrap';
import { Link } from 'react-router-dom';
import './NavMenu.css';

export default class NavMenu extends React.PureComponent<{}> {

    public render() {
        return (

            <section className="panel panel-banner">
                <header className="banner_content banner_content-inverted">
                    <Container className="site-width">
                        <Row>
                            <Col>
                                <h1 className="banner_content_title">Make a Payment</h1>
                            </Col>
                            </Row>
                    </Container>
                </header>
            </section>

        );
    }

}
